<div *ngIf="!isNonDomestic" mat-dialog-title class="markdown-title" markdown [data]="contentTitle"></div>
<div *ngIf="!!isNonDomestic" mat-dialog-title class="markdown-title">
  <h4><strong>Is this a business address?</strong></h4>
</div>
<div *ngIf="!isPostcodeNotSupported">
  <mat-dialog-content aria-label="Dialog Content">
    <!-- Any error messages or alert messages we will display the content here with the specefic buttons -->
    <div *ngIf="!isNonDomestic">
      <div class="modal-body">
        <div>
          <div class="text-center" *ngIf="isLoading">
            <img class="pointer spin-loader" alt="loader" src="./assets/images/compLoader.gif">
          </div>
          <div *ngIf="!isLoading">
            <!-- Switch in progress without loggedIn -->
            @if (!isLoggedIn && isQuotesPageInProgressSwitch) {
            <div class="fs-17 mb-2">
              <p>
                You can’t make another switch just yet. Don’t worry, once your current switch is complete, you can
                switch again during your cooling-off period.
              </p>
              <p>
                Your switch status may still say ‘switch in progress’ if your new supplier has rejected the switch but
                has not yet informed us.
              </p>
              <p>
                Sign in to see the status of your switch.
              </p>
            </div>
            } @else {
            <div class="fs-17 mb-2" markdown [data]="contentText"></div>
            }
          </div>
        </div>
      </div>
    </div>
    <!-- Business meter dialog popup -->
    <div *ngIf="!!isNonDomestic">
      <!-- <div class="modal-title mb-2" id="modal-basic-title">
        <div class="modal-title-message" >Is this a business address?</div>
      </div> -->
      <div class="modal-body">
        <div>
          <span *ngIf="!!isNonDomestic" class="fs-17 mb-2">We think this address may be registered to a business.</span>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" aria-label="Dialog Actions"
    class="d-flex flex-column flex-sm-row align-items-stretch gap-2">
    <!-- Non-Domestic meter -->
    @if (isNonDomestic) {
    <button id="EnergyComparison_BusinessAddressModal_ThisAddressHasABusinessMeter_ChangeAddress"
      class="btn btn-primary-outline order-2 order-md-1" (click)="result()">Yes, it's a
      business</button>

    <button id="EnergyComparison_BusinessAddressModal_ThisAddressHasABusinessMeter_CompareBusinessEnergy"
      class="btn btn-primary order-1 order-sm-2" *ngIf="!!isNonDomestic" (click)="goToExceptionalFlow()">No, it's a
      home</button>
    }

    <!-- Secondary button - common for closing button -->
    <button
      [id]="isQuotesPageInProgressSwitch ? 'EnergyComparison_YourTariffs_SwitchInProgressModel_Close' : isSwitchPageInProgressSwitch? 'EnergyComparison_SwitchApplication_SwitchInProgressModel_Close' : isCancelSwitch ? 'EnergyComparison_YourEnergyDashboard_CancelSwitch_GoBack' : isCampaignTrue ? 'EnergyComparison_SwitchApplication_NotEligibleForCampaign_Cancel' : 'EnergyComparison_YourEnergyDashboard_MessaePopupModal_Close'"
      *ngIf="!isNonDomestic"
      [ngClass]="isCampaignTrue ? 'btn btn-primary-link order-2 order-md-1' : isQuotesPageInProgressSwitch ? 'btn btn-primary-outline order-2 order-md-1' : 'btn btn-primary order-2 order-md-1'"
      (click)="!!isCancelSwitch ? closeInfoPopup() : !!isCampaignTrue ? closeInfoPopup() : closeInfoPopup()">{{!!isCancelSwitch
      ? 'Go back' : !!isCampaignTrue ? 'Cancel' : 'Close'}}</button>


    <!-- Primary button - Quotes page in progress switch-->
    @if (isQuotesPageInProgressSwitch) {
    <!-- LoggedIn user -->
    @if (isLoggedIn) {
    <button class="btn btn-primary order-1 order-sm-2" (click)="takeMeToDashboard()">Go to Dashboard</button>
    } @else {
    <!-- Non-LoggedIn user -->
    <button class="btn btn-primary order-1 order-sm-2" (click)="signIn()">Sign in</button>
    }
    }

    <!-- Primary button - Switch page in progress switch -->
    <button id="EnergyComparison_YourEnergyDashboard_AboutYourSwitch_ContinueComparePrices"
      class="btn btn-primary order-1 order-sm-2" *ngIf="!!isSwitchpending" (click)="navigateToEnergyResult()">Continue
      comparing prices</button>

    <!-- Primary button - Not eligible for campaign -->
    <button id="EnergyComparison_SwitchApplication_NotEligibleForCampaign_ReturnToResults"
      class="btn btn-primary order-1 order-sm-2" *ngIf="!!isCampaignTrue" (click)="returnToResult()">Return to
      results</button>

    <!-- Primary button - Cancel switch -->
    <button id="EnergyComparison_YourEnergyDashboard_AboutYourSwitch_ContinueToSupplier"
      class="btn btn-primary order-1 order-sm-2 supplierLogoBtn" *ngIf="!!isCancelSwitch" (click)="switchCancelAPI()">
      Continue to supplier
      <img src="../../../../assets/ctm-images/ico-supplier.svg" class="ms-1" alt="Supplier" />
    </button>
  </mat-dialog-actions>
</div>

<div *ngIf="isPostcodeNotSupported">
  <mat-dialog-content aria-label="EditPostcode Dialog Content"
    class="d-flex flex-column flex-sm-row align-items-stretch gap-2">
    <div class="modal-body">
      <div class="">
        <div>
          <div class="fs-17 mb-2" markdown [data]="contentTitle"></div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" aria-label="EditPostcode Dialog Content">
    <button class="btn btn-primary order-1 order-sm-2" (click)="changeAddress()">Edit Postcode</button>
  </mat-dialog-actions>
</div>